"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextField = void 0;
const field_types_1 = require("../../types/field_types");
const datasheet_1 = require("../datasheet");
const text_base_field_1 = require("./text_base_field");
class TextField extends text_base_field_1.TextBaseField {
    static defaultProperty() {
        return null;
    }
    static createDefault(fieldMap) {
        return {
            id: datasheet_1.DatasheetActions.getNewFieldId(fieldMap),
            name: datasheet_1.DatasheetActions.getDefaultFieldName(fieldMap),
            type: field_types_1.FieldType.Text,
            property: this.defaultProperty(),
        };
    }
}
exports.TextField = TextField;
//# sourceMappingURL=text_field.js.map